export default (numerator, denominator) => {
    if (numerator && denominator) {
        return `${(numerator / denominator * 100).toFixed(2)}%`;
    }

    return '0%';
};
